import React from "react";
import Modal from "react-modal";
import {
  BENEFIT_SHEET_TABS,
  FIRE_RULES_PDF_LINK,
  MOCK_FIRE_RULES_BULLETS,
  MOCK_FIRE_RULES_TITLE,
  MOCK_TNDS_BULLETS,
  MOCK_TNDS_CARD_TITLE,
  benefitSheetModalStyles,
} from "../constants";
import BenefitBulletList from "./BenefitBulletList";

const TAB_IDS = {
  detail: "fe-sheet-tab-detail",
  rules: "fe-sheet-tab-rules",
};

const PANEL_IDS = {
  detail: "fe-sheet-panel-detail",
  rules: "fe-sheet-panel-rules",
};

export default function BenefitSheetModal({
  isOpen,
  onClose,
  activeTab,
  onTabChange,
}) {
  const isDetail = activeTab === BENEFIT_SHEET_TABS.detail;
  const isRules = activeTab === BENEFIT_SHEET_TABS.rules;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={benefitSheetModalStyles}
      contentLabel="Chi tiết quyền lợi và quy tắc"
      closeTimeoutMS={220}
    >
      <div className="fire-explosion__sheet">
        <div className="fire-explosion__sheet-handle" aria-hidden />
        <button
          type="button"
          className="fire-explosion__sheet-close"
          onClick={onClose}
          aria-label="Đóng"
        >
          ×
        </button>
        <div
          className="fire-explosion__sheet-tabs"
          role="tablist"
          aria-label="Nội dung chi tiết bảo hiểm"
        >
          <button
            id={TAB_IDS.detail}
            type="button"
            role="tab"
            aria-selected={isDetail}
            aria-controls={PANEL_IDS.detail}
            tabIndex={isDetail ? 0 : -1}
            className={`fire-explosion__sheet-tab${isDetail ? " fire-explosion__sheet-tab--active" : ""
              }`}
            onClick={() => onTabChange(BENEFIT_SHEET_TABS.detail)}
          >
            Chi tiết quyền lợi
          </button>
          <button
            id={TAB_IDS.rules}
            type="button"
            role="tab"
            aria-selected={isRules}
            aria-controls={PANEL_IDS.rules}
            tabIndex={isRules ? 0 : -1}
            className={`fire-explosion__sheet-tab${isRules ? " fire-explosion__sheet-tab--active" : ""
              }`}
            onClick={() => onTabChange(BENEFIT_SHEET_TABS.rules)}
          >
            Quy tắc bảo hiểm
          </button>
        </div>
        <div
          id={PANEL_IDS.detail}
          role="tabpanel"
          className="fire-explosion__sheet-body"
          aria-labelledby={TAB_IDS.detail}
          hidden={!isDetail}
        >
          <h3 className="fire-explosion__sheet-panel-title">
            {MOCK_TNDS_CARD_TITLE}
          </h3>
          <BenefitBulletList items={MOCK_TNDS_BULLETS} />
        </div>
        <div
          id={PANEL_IDS.rules}
          role="tabpanel"
          className="fire-explosion__sheet-body"
          aria-labelledby={TAB_IDS.rules}
          hidden={!isRules}
        >
          <h3 className="fire-explosion__sheet-panel-title">
            {MOCK_FIRE_RULES_TITLE}
          </h3>
          <BenefitBulletList items={MOCK_FIRE_RULES_BULLETS} />
          <a
            href={FIRE_RULES_PDF_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="fire-explosion__sheet-rules-link"
          >
            Xem toàn bộ Quy tắc bảo hiểm tại đây →
          </a>
        </div>
        <div className="fire-explosion__sheet-footer">
          <button
            type="button"
            className="fire-explosion__sheet-understood-btn"
            onClick={onClose}
          >
            Đã hiểu
          </button>
        </div>
      </div>
    </Modal>
  );
}
